/**
 * Core font library:
 *
 * https://www.figma.com/file/zYke5qihweC8yQSpXpcRO2/%F0%9F%93%9000-OM-CORE-Library?node-id=51%3A603
 */

// ============================================================================
// README
// ----------------------------------------------------------------------------
// The following objects are taken directly from the CORE figma diagram.
// No additions or changes should be made here, except to align with the CORE
// diagram.
// Changes to the CORE diagram should go through the process defined in RFC009.
// ============================================================================

export const TYPEFACES = {
  HEADING: 'Montserrat, Veranda, sans-serif',
  BODY: 'Lato, Arial, sans-serif',
};

type fontStyleNames =
  | 'H1'
  | 'H2'
  | 'H3'
  | 'H4'
  | 'H5'
  | 'H6'
  | 'BADGE_LABEL'
  | 'BODY'
  | 'BODY_LINK'
  | 'BODY_SMALL'
  | 'LABEL'
  | 'LABEL_SMALL_BOLD'
  | 'LABEL_SMALL'
  | 'BUTTON';

export type fontStyle = {
  fontFamily: string;
  fontStyle: 'normal';
  fontWeight: 'bold' | 'normal' | number;
  fontSize: string;
  lineHeight: string;
  textDecorationLine?: 'underline';
};

export const FUTURO_TYPEFACES: { [k in fontStyleNames]: fontStyle } = {
  H1: {
    fontFamily: TYPEFACES.HEADING,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '3rem',
    lineHeight: '3.5rem',
  },
  H2: {
    fontFamily: TYPEFACES.HEADING,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '2rem',
    lineHeight: '2.5rem',
  },
  H3: {
    fontFamily: TYPEFACES.HEADING,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },
  H4: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 900,
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
  },
  H5: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },
  H6: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  BADGE_LABEL: {
    fontFamily: TYPEFACES.HEADING,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '0.5rem',
    lineHeight: '0.75rem',
  },
  BODY: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
  BODY_LINK: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    textDecorationLine: 'underline',
  },
  BODY_SMALL: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  LABEL: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },
  LABEL_SMALL_BOLD: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  LABEL_SMALL: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  BUTTON: {
    fontFamily: TYPEFACES.BODY,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },
};

const FONT = {
  FUTURO: FUTURO_TYPEFACES,
};

export default FONT;
